module.exports = __webpack_public_path__ + "img/ComentariosIcon.6b2986ab.svg";